import axios from 'axios';
import get from 'lodash.get';

const updateProfileUrl = '/profile';

export const updateProfile = async (fullName, email, shouldReceiveWeeklyDigest) => {
  try {
    const response = await axios.post(updateProfileUrl, {
      name: fullName,
      email,
      shouldReceiveWeeklyDigest,
    });
    return get(response, 'data') || {};
  } catch (error) {
    throw new Error(`Error updating profile: ${error?.message}`);
  }
};
